import { LocalStorage } from '../../class/local-storage';
import { Injectable } from '@angular/core';
import { Platform } from "@ionic/angular";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CONSTANTS } from "src/app/config/constants";
@Injectable({
	providedIn: 'root'
})
export class AppService {

	private resumeSubject = new Subject<null>();
	private isBackgroundSubject = new BehaviorSubject<boolean>(false);

	constructor() { }

	public displayDisclosureMessage(platform: Platform): boolean {
		return (
			platform.is('android') &&
			LocalStorage.get(CONSTANTS.localStorage.keys.locationDisclosureAccepted, 0) === 0
		);
	}

	public locationAllowed(platform: Platform): boolean {
		return (
			!platform.is('android') ||
			LocalStorage.get(CONSTANTS.localStorage.keys.locationDisclosureAccepted) === 1
		);
	}

	public clearShiftLocalStorage() {
		LocalStorage.remove(CONSTANTS.localStorage.keys.lastSiteByShift);
	}

	public resume() {
		this.resumeSubject.next(null);
	}

	public resumeListener(): Observable<null> {
		return this.resumeSubject.asObservable();
	}
}